module.exports = __webpack_public_path__ + "assets/resin.f5793847.svg";